module.exports = __webpack_public_path__ + "static/media/ahri-win.a7f69537.png";